import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.scss';
import Popover from "jd-library/Popover";
import toastMessageActions from "jd-library/toastMessageActions";
import { dataArys } from './utils';

const ProductScorePopUp = ({ productId, isPopUpOpenFunc, finalWeight, isBranded, isServiceScore }) => {

    const containerRef = useRef();
    const [totalScore, setTotalScore] = useState(0)
    const [dataAry, setDataAry] = useState([])
    const [isPop, setIsPop] = useState(false)
    const dispatch = useDispatch();
    const docId = useSelector(state => state.session.docId)

    useEffect(() => {
        const roundOf = Number(Math.round((Number(finalWeight) + Number.EPSILON) * 100) / 100);
        setTotalScore(roundOf)
    }, [finalWeight])

    const stopPropogation = (event) => {
        event && event.stopPropagation();
    };

    const productScoreClick = () => {
        if (isPop) {
            setIsPop(false)
        } else {
            setIsPop(true)
            dataArys(productId, docId, isBranded, isServiceScore, (tempAry, msg = "") => {
                if (tempAry.length) {
                    setDataAry(tempAry)
                } else {
                    containerRef.current.click();
                    dispatch(toastMessageActions.showMessage({
                        message: msg,
                        type: "error",
                        showReduxToast: true,
                        duration: 5000,
                    }));
                }
            })
        }
    }

    const PopUpData = () => {
        useEffect(() => {
            isPopUpOpenFunc(true)
            return () => {
                setIsPop(false)
                isPopUpOpenFunc(false)
            }
        }, [])
        let score = 0
        if (dataAry.length === 0) {
            return (
                Array(4).fill(1).map((curP) => {
                    return (
                        <div className="shimmer-container" key={curP}>
                            <span className="title shimmer-loader" />
                            <div className="desc">
                                {
                                    Array(3).fill(1).map((curC) => {
                                        return (
                                            <div className="child" key={`${curP}${curC}`}>
                                                <p className="label shimmer-loader" />
                                                <p className="value shimmer-loader" />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            )
        }
        return (
            <div className="pop-up-div-container">
                {
                    dataAry.length > 0 && dataAry.map((item, ind) => {
                        return (
                            <div className={`pop-up-outer-div ${dataAry.length != 1 && dataAry.length == ind + 1 ? "removeBtmAddTop" : ""} ${dataAry.length == 1 ? "removeIBtm" : ""}`} key={ind}>
                                {item.key ? <b className="leftSpan">{item.key}</b> : null}
                                {
                                    item?.valAry?.length > 0 && item?.valAry.map((inItem, inInd) => {
                                        score += inItem?.value || 0
                                        return (
                                            <div className={`pop-up-inner-div ${dataAry.length == 1 && item?.valAry.length == inInd + 1 ? "removeBtmAddTop" : ""}`} key={`${ind}${inInd}`}>
                                                {
                                                    inItem.key === "Total" ?
                                                        <>
                                                            <span className="leftSpan"><b>{inItem.key}</b></span>
                                                            <span className="rightSpan"><b>{`${score}/${inItem.exp}`}</b></span>
                                                        </>
                                                        :
                                                        <>
                                                            <span className={`${inItem.value == inItem.exp ? "active" : "inactive"} leftSpan`}>{inItem.key}</span>
                                                            <span className={`${inItem.value == inItem.exp ? "active" : "inactive"} rightSpan`}>{`${inItem.value}/${inItem.exp}`}</span>
                                                        </>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div className={styles['product-score-placeholder']} ref={containerRef} onClick={stopPropogation}>
            <Popover
                containerEle={containerRef}
                content={<PopUpData />}
                eventType="click"
                fixToBottom={true}
                className="pop-over-class"
                arrowClass="pop-over-arrow-class">
                <div
                    className={styles['product-score-pls']}
                    onClick={productScoreClick}
                    tabIndex={0}
                    role="button"
                    aria-label={`${isServiceScore ? "Service" : "Product"} Score: ${totalScore}. Click to view details`}
                    onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); e.preventDefault(); e.currentTarget.click(); } }}
                >{isServiceScore ? "Service" : "Product"} Score: {totalScore}</div>
            </Popover>
        </div>
    )
}

export default ProductScorePopUp